export enum ErrorMessagesEnum {
  SOMETHING_WENT_WRONG = 'Something went wrong.',
  NETWORK_ERROR = 'There was a problem with internet connection.',
  BAD_GATEWAY = 'Gateway Timeout',
  INTERNAL_SERVER_ERROR = 'Internal server error.',
}
